import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {createBrowserHistory} from 'history';
import * as Sentry from '@sentry/browser';
import './styles/pagination.scss';
import App from './App';
import configureStore from './store/configureStore';
import * as serviceWorker from './serviceWorker';
import './index.css';
import './styles/rich-text-content.scss';

const store = configureStore();
const history = createBrowserHistory();

window.addEventListener('error', (e) => {
  if (
    e.message ===
    'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
});

history.listen((location) => {
  window.analytics.page();
});

if(process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://2ff387b23955400aa2e65730a238040b@sentry.io/5172760",
    release: process.env.AWS_COMMIT_ID,
    environment: process.env.REACT_APP_STAGE
  });
}

ReactDOM.render(
    <Provider store={store}>
        <App history={history} />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
